<div class="top-header-wrapper">
    <div class="top-header-inner-wrapper">
        <div class="translate">
            <a class="link colored" [attr.data-text]="this.activeLocale == 'en' ? 'Français' : 'English'" (click)=" this.activeLocale == 'en' ? switchLocale('fr') : switchLocale('en')">{{
                this.activeLocale == 'en' ? 'Français' : 'English'}}</a>
            <!-- <div class="th-col">
            <a class="link" (click)="goToPage('url', $event, false)" i18n="@@forHome">For Home</a>
            <div class="divider"></div>
            <a class="link" (click)="goToPage('url', $event, false)" i18n="@@forBusiness">For Business</a>
        </div> -->
        </div>

        <div *ngIf="!hideAt$l" class="g-divider"></div>
        <div class="th-col">
            <!-- <div *ngIf="!hideAt$l"><span i18n="@@smellPropaneCall">Smell Propane? Call</span>&nbsp;<a class="link"
                    [href]="'tel:'+phoneNumber">{{ phoneNumber }}</a></div> -->
            
            <div *ngIf="!hideAt$l"><span i18n="@@smellPropane">Smell Propane? </span>&nbsp;
                <a class="link underline" (click)="goToBranches()">
                    <ng-container i18n="@@clickHere">Click Here</ng-container>
                </a>&nbsp;<span><ng-container i18n="@@forAllDaySupport">for 24/7 Support</ng-container></span>
            </div>
            <!-- <div class="divider" *ngIf="!hideAt$l" ></div> -->
            <!-- <div class="search">
                <img src="assets/icons/search.svg" />
            </div> -->
            <ul class="right-menu-items" *ngIf="!hideAt$l">
                <ng-container *ngFor="let menuItem of rightMenuItems; index as i;">
                    <li *ngIf="menuItem.inDesktop">
                        <a class="link colored" (click)="goToPage(menuItem.url, $event)">{{ menuItem.label }}</a>
                    </li>
                </ng-container>
            </ul>
        </div>
        <div class="dropdown">
            <div class="c-dropdown-toggle" data-bs-toggle="dropdown">
                <span class="user-name">
                    <div>
                        @if (customers.length > 0) {
                        @for (customer of customers; track $index) {
                        @if (customer.customerId === parseInt(currentCustomerId)) {
                        <div class="the-button">
                            <span class="accountId-label">{{ customer.legacyId }}</span>
                            <div class="g-divider"></div>
                            <span class="account-name">{{ customer.name }}</span>
                            <img class="image-icon" src="assets/icons/arrow-down-blue.svg">
                            <img class="image-icon default" src="assets/icons/briefcase-default.svg">
                            <img class="image-icon hover" src="assets/icons/briefcase-hover.svg">
                        </div>
                        }
                        }
                        }

                    </div>
                </span>
            </div>

            <!-- Dropdown Menu -->
            <div class="dropdown-menu">
                <div class="menu-container">
                    @for (customer of customers; track $index) {
                    <div class="account-id-name"
                        (click)="customerStore.selectCustomer(customer.customerId)">
                        <span
                            [ngClass]="{'selected': customer.customerId == parseInt(currentCustomerId)}"
                            class="account-id">
                            {{ customer.legacyId }} - {{ customer.name }}
                        </span>
                        @if(customer.customerId == parseInt(currentCustomerId)) {
                        <img src="assets/icons/check.svg" alt="">
                        }
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>